import { filter } from 'lodash';
import * as ActionTypes from '../components/actions/types';

const initialState = [];

function cmsEventJudgingCriteriaReducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.FETCH_CMS_EVENT_JUDGING_CRITERIA:
      return action.payload;
    case ActionTypes.CREATE_CMS_EVENT_JUDGING_CRITERIA:
      return [...state, action.payload];
    case ActionTypes.REMOVE_CMS_EVENT_JUDGING_CRITERIA:
      return filter(state, jc => jc.id !== action.payload);
    case ActionTypes.UPDATE_CMS_EVENT_JUDGING_CRITERIA:
      return state.map(
        jc => (jc.id === action.payload.id ? action.payload : jc),
      );
    case ActionTypes.REORDER_CMS_EVENT_JUDGING_CRITERIA: {
      return action.payload;
    }
    default:
      return state;
  }
}

export default cmsEventJudgingCriteriaReducer;



// WEBPACK FOOTER //
// ./src/reducers/cmsEventJudgingCriteria.js